import type { HTMLAttributes } from 'react';

import { useReportData } from '@/hooks/useReportData';
import { toTimeHistoryReportTableDataSource } from '@/lib/mappers/timeHistoryReport';
import type { TimeHistoryReportFormValues } from '@/types/TimeHistoryReportFormValues';

import { DataTable } from '../ui/data-table';

type TimeHistoryReportTableProps = {
  filterData: TimeHistoryReportFormValues;
};

export default function TimeHistoryReportTable({
  filterData,
  ...rest
}: TimeHistoryReportTableProps & HTMLAttributes<HTMLDivElement>) {
  const { reportData, getFilteredTimesheetEntries } = useReportData();

  const timeSheet = getFilteredTimesheetEntries(filterData);
  const userContext = reportData?.userContext;

  const { columns, data, totalHours } = toTimeHistoryReportTableDataSource({
    timeSheet,
    userContext,
  });

  return (
    <div className="flex h-full flex-col" {...rest}>
      <DataTable
        tableContainerClassName="overflow-auto flex-grow min-h-0"
        tableClassName="[&_thead]:sticky [&_thead]:top-0 [&_thead]:bg-navigation [&_thead]:z-10"
        dataTestId="timeHistoryReportTable"
        columns={columns}
        data={data}
        paginate={false}
        summary={<TimeHistoryReportTableSummary totalHours={totalHours} />}
      />
    </div>
  );
}

type TimeHistoryReportTableSummaryProps = {
  totalHours: number;
};

function TimeHistoryReportTableSummary({
  totalHours,
}: TimeHistoryReportTableSummaryProps & HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 className="py-2">
      Total Hours: <span className="font-semibold">{totalHours}</span>
    </h3>
  );
}
